export default async function verifyUserReq(userUuid, token) {
  return fetch(`${process.env.REACT_APP_HELDR_API_URL}/signup/verify/${userUuid}/${token}`, {
    method: 'GET',
  });
}
